/* eslint-disable */
import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';

// URL functions
import { fetchPatientsIdtf, fetchPatientAutoCompleteIdtf } from 'legacy/containers/ApiUrls';

// Constants Types
import {
  IDTF_PATIENTS_DATA_REQUEST,
  IDTF_PATIENTS_DATA_SUCCESS,
  IDTF_PATIENTS_DATA_FAILURE,
  IDTF_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT,
  IDTF_PATIENTS_AUTO_COMPLETE_DATA_SUCCESS,
} from './types';

// ------------------------------------
// Actions
// ------------------------------------
export const kardiRxIdtfPatientDataRequest = () => ({
  type: IDTF_PATIENTS_DATA_REQUEST,
});
export const kardiRxIdtfPatientDataSuccess = data => ({
  type: IDTF_PATIENTS_DATA_SUCCESS,
  payload: data,
});

export const kardiRxIdtfPatientAutoCompleteDataSuccess = data => ({
  type: IDTF_PATIENTS_AUTO_COMPLETE_DATA_SUCCESS,
  payload: data,
});

export const kardiRxIdtfPatientDataFailure = () => ({
  type: IDTF_PATIENTS_DATA_FAILURE,
});

export const getKardiaRxPatientsData = (forceUpdate = false, pageLimt = 249,
  page = 1, identifier, identifierCheck) => (
  dispatch,
  getState,
) => {
  dispatch(kardiRxIdtfPatientDataRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = me.data;
      const apiCalls = [];
      apiCalls.push(dispatch(fetchPatientsIdtf(teams[0].id, identifier, identifierCheck, pageLimt, page)));
      return Promise.all(apiCalls);
    })
    .then(data => {
      return dispatch(kardiRxIdtfPatientDataSuccess(data));
    })
    .catch(err => {
      // console.log('getKardiaRxPatientsData', err);
      // dispatch(kardiRxIdtfPatientDataFailure());
      return dispatch(kardiRxIdtfPatientDataFailure());
    });
};


export const getKardiaRxPatientsAutoComplete = (forceUpdate = false, identifier) => (
  dispatch,
  getState,
) => {
  dispatch(kardiRxIdtfPatientDataRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = me.data;
      const apiCalls = [];
      apiCalls.push(dispatch(fetchPatientAutoCompleteIdtf(teams[0].id)));
      return Promise.all(apiCalls);
    })
    .then(data => {
      // return dispatch(kardiRxIdtfPatientDataSuccess(data));
      return dispatch(kardiRxIdtfPatientAutoCompleteDataSuccess(data));

    })
    .catch(err => {
      console.log('getKardiaRxPatientsAutoCompleteData', err);
      // dispatch(kardiRxIdtfPatientDataFailure());
      // return dispatch(kardiRxIdtfPatientDataFailure());
    });
};



export const handleOnRefreshClick = () => (dispatch, getState) => {
  dispatch(getKardiaRxPatientsData(true));
};

export const searchSubmit = data => ({
  type: IDTF_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT,
  payload: data,
});



// WEBPACK FOOTER //
// ./src/views/state/kardiaRxIdtf/KardiaRxIDTFPatientsActions.js